var map = {
	"./thumnail_1.png": 9127,
	"./thumnail_10.png": 5927,
	"./thumnail_2.png": 396,
	"./thumnail_3.png": 7909,
	"./thumnail_4.png": 3242,
	"./thumnail_5.png": 6384,
	"./thumnail_6.png": 9512,
	"./thumnail_7.png": 2225,
	"./thumnail_8.png": 6070,
	"./thumnail_9.png": 1167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1453;